import { render, staticRenderFns } from "./nav-control.vue?vue&type=template&id=3152cf10&scoped=true&"
import script from "./nav-control.vue?vue&type=script&lang=js&"
export * from "./nav-control.vue?vue&type=script&lang=js&"
import style0 from "./nav-control.vue?vue&type=style&index=0&id=3152cf10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3152cf10",
  null
  
)

export default component.exports